import CollapsibleItem from './CollapsibleItem'

export default CollapsibleItem
